import { useCallback, useEffect, useState } from "react";
import { api, extractError } from "../lib/api";
import { useBootstrapWS } from "./useBootstrapWS";
import { toast } from "sonner";

/** Unified boiler activity log register. */
export function useBoilerRegister({ limit = 100 } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const res = await api.get("/boiler/register", { params: { limit } });
      setData(res.data);
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    reload();
  }, [reload]);

  useBootstrapWS(["boiler_logging"], reload);

  return {
    loading,
    reload,
    entries: data?.entries || [],
    total: data?.total ?? 0,
  };
}
